<template>
	<div class="col-sm-12 what-now-settings">
		<div class="box">
			<div class="box-header">
				<h2 class="box-title">What Now Ranges</h2>
			</div>
			<div class="box-body">

				<fieldset class="form-horizontal">

					<div class="row">
						<div class="col-md-6">
							<legend>Temperature (&deg;C)</legend>

							<div class="row">
								<div class="col-sm-6">
									<input-text name="temperature_low" :vmodel.sync="whatNow.temperature_low" :spinner="true" postfix="&deg;C" label="Low"></input-text>
								</div>
								<div class="col-sm-6">
									<input-text name="temperature_high" :vmodel.sync="whatNow.temperature_high" :spinner="true" postfix="&deg;C" label="High"></input-text>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<legend>Add DAP (mg/L)</legend>

							<div class="row">
								<div class="col-sm-6">
									<input-text name="dap_low" :vmodel.sync="whatNow.dap_low" :spinner="true" label="Low" postfix="mg/L"></input-text>
								</div>
								<div class="col-sm-6">
									<input-text name="dap_high" :vmodel.sync="whatNow.dap_high" :spinner="true" label="High" postfix="mg/L"></input-text>
								</div>
							</div>
						</div>
					</div>

					<div class="row">
						<div class="col-md-6">
							<legend>Agitator</legend>

							<div class="row">
								<div class="col-sm-6">
									<input-text name="agitator_low" :vmodel.sync="whatNow.agitator_low" :spinner="true" label="Low"></input-text>
								</div>
								<div class="col-sm-6">
									<input-text name="agitator_high" :vmodel.sync="whatNow.agitator_high" :spinner="true" label="High"></input-text>
								</div>
							</div>
						</div>
						<div class="col-md-6">
							<legend>Overseed (mg/L)</legend>

							<div class="row">
								<div class="col-sm-6">
									<input-text name="reinoculate_low" :vmodel.sync="whatNow.reinoculate_low" :spinner="true" label="Low" postfix="mg/L"></input-text>
								</div>
								<div class="col-sm-6">
									<input-text name="reinoculate_high" :vmodel.sync="whatNow.reinoculate_high" :spinner="true" label="High" postfix="mg/L"></input-text>
								</div>
							</div>
						</div>
					</div>

				</fieldset>
			</div>
		</div>
	</div>
</template>

<script>
	import { whatNow } from 'vx/getters'
	import { Settings as SettingActions } from 'vx/actions'
	import Notify from 'utils/notify'

	export default {
		vuex: {
			getters: {
				whatNow
			},
			actions: {
				allWhatNow: SettingActions.allWhatNow,
				updateWhatNow: SettingActions.updateWhatNow
			}
		},

		data() {
			return {
				dictionary: {
					temperature_high: 'Temperature High',
					temperature_low: 'Temperature Low',
					dap_high: 'DAP High',
					dap_low: 'DAP Low',
					reinoculate_high: 'Reinoculate High',
					reinoculate_low: 'Reinoculate Low',
					agitator_high: 'Agitator High',
					agitator_low: 'Agitator Low'
				},
				timeouts: {
					temperature_high: null,
					temperature_low: null,
					dap_high: null,
					dap_low: null,
					reinoculate_high: null,
					reinoculate_low: null,
					agitator_high: null,
					agitator_low: null
				}
			}
		},

		created() {
			this.allWhatNow().then(() => {
				this.$watch('whatNow.temperature_low', value => this.save('temperature_low', value));
				this.$watch('whatNow.temperature_high', value => this.save('temperature_high', value));
				this.$watch('whatNow.dap_low', value => this.save('dap_low', value));
				this.$watch('whatNow.dap_high', value => this.save('dap_high', value));
				this.$watch('whatNow.reinoculate_low', value => this.save('reinoculate_low', value));
				this.$watch('whatNow.reinoculate_high', value => this.save('reinoculate_high', value));
				this.$watch('whatNow.agitator_low', value => this.save('agitator_low', value));
				this.$watch('whatNow.agitator_high', value => this.save('agitator_high', value));
			});
		},

		ready() {

		},

		methods: {
			save(name, value) {
				if (this.timeouts[name]) {
					clearTimeout(this.timeouts[name]);
				}

				this.timeouts[name] = setTimeout(() => {
					this.updateWhatNow(name, value).then(() => {
						Notify.success(`${this.dictionary[name]} has been updated.`, { timeout: 2500 });
					});
				}, 1250);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// what-now.vue?6ea0103d